export const getDeepestCommonCategoryId = (publicaciones) => {
  if (!publicaciones?.length) {
    return null
  }

  // Parseamos las categorias, filtrando las que no tienen categoriaRoot
  const paths = publicaciones
    .filter((pub) => pub.categoriaRoot)
    .map((pub) => {
      try {
        return JSON.parse(pub.categoriaRoot)
      } catch {
        // Error parsing categoriaRoot, se ignora esta publicación
        return null
      }
    })
    .filter(Boolean) // Eliminamos los null

  // Si no hay paths válidos, retornamos null
  if (!paths.length) {
    return null
  }

  // Encontramos la longitud mínima
  const minLength = Math.min(...paths.map((p) => p.length))

  const commonPath = []

  for (let i = 0; i < minLength; i++) {
    const { id, name } = paths[0][i]
    const allMatch = paths.every((p) => p[i].id === id)

    if (allMatch) {
      commonPath.push({ id, label: name })
    } else {
      break
    }
  }

  return commonPath.length ? commonPath : null
}
